<template>
  <!-- 首頁 -->
  <div id="app">
    <!-- 第二塊內容 -->
    <div style="width: 100%;text-align: center;padding-top: 130px;background-color: rgb(237, 240, 245);">
      <!-- 系統 -->
      <div style="display: flex; justify-content: center; width: 100%;">
        <div style="width: 1400px; display: flex; ">
          <el-row style="width: 100%;">
            <el-col :sm="24" :md="12" :xl="6" v-for="(item, index) in projects" :key="index"
              style="flex: 1; text-align: center; margin-bottom: 60px;" data-aos="zoom-in" data-aos-duration="1700">
              <img :src="require('@/assets/' + item.icon + '.png')" style="width: 40px; margin-bottom: 20px;" alt="">
              <div style="font-size: 32px; font-weight: 800; color: #22252A;">{{ item.cn }}</div>
              <div style="margin-top: 6px; color: grey; font-size: 16px;">{{ item.en }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 卡片 -->
      <div style="display: flex; justify-content: center; padding: 20px;">
        <div id="card" style="margin-top: 60px; width: 1400px; ">
          <el-row :gutter="20" style="">
            <el-col :sm="24" :md="12" :xl="6" v-for="(item, index) in companyIntroduction" :key="index"
              data-aos="zoom-in" data-aos-duration="1700">
              <div :style="'background-color: ' + item.color + '; margin: 20px 0px; border-radius: 20px;'">
                <div style="padding: 40px 20px; font-size: 20px; color: white; font-weight: 600;">
                  <div>{{ item.text }}</div>
                </div>
              </div>

            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 點燃創意 -->
      <div style="display: flex; justify-content: center;">
        <div style="margin-top: 80px; width: 1400px;">
          <!-- 頭文字 -->
          <div style="margin: auto;">
            <div style="text-align: left;width: 100%;padding: 30px;">
              <div style="font-size: 3.6em;font-weight: bold;margin-bottom: 16px;">
                智匯前沿 創領未來
              </div>
              <div style="font-size: 1.6em;font-weight: 600; color: grey">
                聚焦全球技術趨勢，深度解析行業痛點，提供前瞻性解決方案</div>
            </div>
          </div>

          <!-- 雙排 -->
          <div style="display: flex;justify-content: center;padding: 30px 0;">
            <div style="display: flex; justify-content: center;align-items: center;">
              <div style="" data-aos="fade-left" data-aos-duration="1700">
                <div style="display: flex; justify-content: center;">
                  <!-- <div id="container-or-iframe-selector" style="width: 100%;"></div> -->
                  <img src="@/assets/xmind.png" alt="" srcset="" style="width: 90%; height: 100%;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第三塊內容 -->
    <div style="display: flex; justify-content: center; background-color: black;">
      <div style="width: 1400px;padding-top: 160px; color: white;">
        <div style="">
          <div>

            <div style="margin: auto;">
              <div style="text-align: left;width: 100%;padding: 30px;">
                <div style="font-size: 3.6em;font-weight: bold;margin-bottom: 16px;">
                  標杆案例 智建未來
                </div>
                <div style="font-size: 1.6em;font-weight: 600; color: grey">
                  聚焦行業痛點，展示跨領域解決方案，呈現客戶價值倍增實踐</div>
              </div>
            </div>

            <!-- 圖片 -->
            <div style="margin-top: 60px;width: 100%;">
              <el-row :gutter="60">
                <el-col :sm="24" :md="12" :xl="12" style="text-align: center; margin-bottom: 60px;" v-for="index in 6"
                  :key="index">
                  <div style="padding: 30px;" data-aos="fade-right" data-aos-duration="1700">
                    <img src="@/assets/a1.png" style="width: 100%;border-radius: 14px;">
                  </div>
                </el-col>
              </el-row>

              <!-- <div style="display: flex;flex-direction: column; align-items: center;margin-bottom: 40px;">
                <el-row>
                  <el-col :sm="24" :md="24" :xl="12" style="text-align: center;">
                    <div style="padding: 10px;" data-aos="fade-right" data-aos-duration="1700">
                      <img src="@/assets/a3.png" style="width: 70%;border-radius: 14px;">
                    </div>
                  </el-col>

                  <el-col :sm="24" :md="24" :xl="12" style="text-align: center;">
                    <div style="padding: 10px;" data-aos="fade-left" data-aos-duration="1700">
                      <img src="@/assets/a4.png" style="width: 70%; border-radius: 14px;">
                    </div>
                  </el-col>
                </el-row>
              </div>

              <div style="display: flex;flex-direction: column; align-items: center;">
                <el-row>
                  <el-col :sm="24" :md="24" :xl="12" style="text-align: center;">
                    <div style="padding: 10px;" data-aos="fade-right" data-aos-duration="1700">
                      <img src="@/assets/a5.png" style="width: 70%;border-radius: 14px;">
                    </div>
                  </el-col>

                  <el-col :sm="24" :md="24" :xl="12" style="text-align: center;">
                    <div style="padding: 10px;" data-aos="fade-left" data-aos-duration="1700">
                      <img src="@/assets/a6.png" style="width: 70%; border-radius: 14px;">
                    </div>
                  </el-col>
                </el-row>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="background-color: black;width: 100%;padding-top: 100px;padding-bottom: 200px; color: white;text-align: center;">
      <!-- 交叉流圖片 -->
      <div style="margin-top: 100px;" data-aos="fade-up" data-aos-duration="1700">
        <div style="max-width: 1300px;margin: auto;">
            <el-row>
              <el-col :sm="24" :md="24" :xl="24" style="text-align: center;">
                <div style="margin-right: 80px; display: flex; flex-direction: column; align-items: center; width: 100%; padding: 30px; margin-bottom: 50px;">
                  <div style="font-size: 2.6em;margin-bottom: 24px;color: #3F81FE;font-weight: bold;">輕量智聯
                    創享未來
                  </div>
                  <div style="font-size: 1.3em;margin-top: 24px; color: #aeb5bd;margin-bottom: 20px;">
                    採用 Flutter/Dart 框架實現 iOS/Android/H5 多端適配，代碼復用率超 80%；獨創敏捷開發中台支持 72 小時快速迭代上線；通過渲染引擎優化與智能預加載技術，頁面加載速度提升
                    40%；基於手勢識別與動效設計，構建絲滑交互體驗。系統支持雲原生架構，提供 API 智能監控與熱修復能力，確保億級用戶穩定訪問。
                  </div>
                </div>
              </el-col>
              <!-- <el-col :sm="24" :md="24" :xl="12" style="text-align: center; height: 600px;">
                <div style="">
                  <img src="@/assets/i1.png" alt="" srcset="" style="width: 70%;border-radius: 10PX;">
                </div>
              </el-col>
              <el-col :sm="24" :md="24" :xl="12" style="text-align: center; height: 600px;">
                <div style="">
                  <img src="@/assets/i2.png" alt="" srcset="" style="width: 70%;border-radius: 10PX;">
                </div>
              </el-col> -->
              <el-col :sm="24" :md="24" :xl="24" style="text-align: center;">
                <div style="margin-right: 80px; display: flex; flex-direction: column; align-items: center; width: 100%; padding: 30px; margin-bottom: 50px;">
                  <div style="font-size: 2.6em;margin-bottom: 24px;color: rgb(61, 197, 93);font-weight: bold;">全棧賦能
                    智構未來
                  </div>
                  <div style="font-size: 1.3em;margin-top: 24px; color: #aeb5bd;margin-bottom: 20px;">
                    採用 React/Vue3
                    構建響應式界面，實現多端適配與秒級渲染；後端基於 Spring Cloud Alibaba 微服務架構，支持萬級並發；通過 K8s+Docker 容器化部署，資源利用率提升
                    60%；構建零信任安全體系，涵蓋數據加密、WAF 防護與威脅感知。系統支持 A/B 測試與智能監控，頁面響應時間小於200ms，可穩定承載百萬級用戶實時交互。
                  </div>
                </div>
              </el-col>
              <el-col :sm="24" :md="24" :xl="24" style="text-align: center;">
                <div style="margin-right: 80px; display: flex; flex-direction: column; align-items: center; width: 100%; padding: 30px; margin-bottom: 50px;">
                  <div style="font-size: 2.6em;margin-bottom: 24px;color: rgb(233, 84, 84);font-weight: bold;">全端開發
                    智聯未來
                  </div>
                  <div style="font-size: 1.3em;margin-top: 24px; color: #aeb5bd;margin-bottom: 20px;">
                    基於 Android
                    Jetpack 組件實現原生性能優化，支持
                    API 33 級深度適配；Windows 端採用 C#/.NET 開發，完成多屏協同與硬件級權限控制；iOS 系統通過 SwiftUI+Combine
                    框架重構交互邏輯，實現動態響應式設計。跨平台方案採用
                    Flutter 引擎，代碼復用率達 75%，支持三端 UI / 功能同步迭代。構建自動化測試矩陣，覆蓋 800 + 機型兼容性驗證，確保系統級穩定性與流暢度。
                  </div>
                </div>
              </el-col>
              <!-- <el-col :sm="24" :md="24" :xl="12" style="text-align: center; height: 600px;">
                <div style="">
                  <img src="@/assets/i3.png" alt="" srcset="" style="width: 70%;border-radius: 10PX;">
                </div>
              </el-col>
              <el-col :sm="24" :md="24" :xl="12" style="text-align: center; height: 600px;">
                <div style="">
                  <img src="@/assets/i4.png" alt="" srcset="" style="width: 70%;border-radius: 10PX;">
                </div>
              </el-col> -->
              <el-col :sm="24" :md="24" :xl="24" style="text-align: center;">
                <div style="margin-right: 80px; display: flex; flex-direction: column; align-items: center; width: 100%; padding: 30px; margin-bottom: 50px;">
                  <div style="font-size: 2.6em;margin-bottom: 24px;color: rgb(255, 236, 89);font-weight: bold;">智碼賦能
                    雲構未來
                  </div>
                  <div style="font-size: 1.3em;margin-top: 24px; color: #aeb5bd;margin-bottom: 20px;">
                    AI
                    驅動的代碼生成引擎支持需求自動解析，代碼交付效率提升 3
                    倍；基於 K8s+Docker 實現雲原生容器化部署，資源利用率優化 60%；自動化測試矩陣覆蓋單元 / 集成 / 壓力測試，缺陷發現率提高
                    40%；容器化管理平台支持秒級彈性伸縮與灰度發佈。系統兼容混合雲環境，適配金融、電商等高並發場景，平均響應時間小於150ms。
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
      </div>

    </div>

    <!-- 第五塊內容 -->
    <div style="width: 100%;padding-top: 120px;padding-bottom: 100px;background-color: rgb(237, 240, 245); display: flex; justify-content: center;">
      <div style="width: 1300px;">

        <div style="margin: auto;">
          <div style="text-align: left;width: 100%;padding: 30px;">
            <div style="font-size: 3.6em;font-weight: bold;margin-bottom: 16px;">
              我們相當重視你的私隱
            </div>
            <div style="font-size: 1.6em;font-weight: 600; color: grey">
              專注思考，無憂無慮</div>
          </div>
        </div>
        <div style="margin: 20px auto auto auto;" data-aos="fade-up" data-aos-duration="1700">
          <el-row :gutter="20">
            <el-col :sm="24" :md="12" :xl="8" v-for="(item, index) in proMessage" :key="index" style="padding: 30px;">
              <div style="border-radius: 30px;text-align: left;padding: 40px;background-color: rgb(255, 255, 255);">
                <div style="font-size: 28px;margin-bottom: 38px;font-weight: bold;">{{ item.table }}</div>
                <div style="font-size: 16px;color: rgba(0, 0, 0, 0.5);">{{ item.mes }}</div>
              </div>
             

            </el-col>
          </el-row>
        </div>
      </div>

    </div>

    <!-- 第六塊內容 -->
    <div
      style="width: 100%;padding-bottom: 100px;background-color: rgb(237, 240, 245);display: flex;justify-content: center;">
      <div style="width: 1300px;margin: auto;">
        <div style="text-align: left;width: 100%;padding: 10px;">
          <div style="font-size: 2.6em;font-weight: bold;margin-bottom: 16px;">
            👏 來自 客戶 的評價
          </div>
          <div style="font-size: 1.3em;font-weight: 600; color: grey">
            真實客戶見證，呈現項目價值倍增，樹立行業標杆案例</div>
        </div>
      </div>

    </div>
    <div style="width: 100%;" data-aos="fade-up" data-aos-duration="1700">
      <img src="@/assets/img1.png" alt="" srcset="" style="width: 100%;">
    </div>

    <!-- 第七塊內容 -->
    <div
      style="width: 100%;padding: 100px 0;background-color: rgb(237, 240, 245);display: flex;justify-content: center;">
      <div style="width: 1300px;margin: auto;">
        <div style="text-align: left;width: 100%;padding: 10px;">
          <div style="font-size: 2.6em;font-weight: bold;margin-bottom: 16px;">
            技術白皮書：智領未來
          </div>
          <div style="font-size: 1.3em;font-weight: 600; color: grey">
            深度解析 AI、雲原生技術，助力企業數碼化轉型</div>
        </div>
      </div>

    </div>
    <div style="width: 100%;" data-aos="fade-up" data-aos-duration="1700">
      <img src="@/assets/img2.png" alt="" srcset="" style="width: 100%;">
    </div>



  </div>
</template>

<script>
import AOS from 'aos';
import VueScrollTo from 'vue-scrollto';
import 'aos/dist/aos.css'
export default {
  name: 'App',
  mounted() {
    AOS.init();


  },

  methods: {
    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500);
    }
  },

  data() {
    return {
      projects: [
        { cn: '小程序', en: 'Mini Program', icon: 'mini' },
        { cn: 'WEB網站', en: 'WEB Site', icon: 'web' },
        { cn: '應用程式', en: 'Application', icon: 'app' },
        { cn: '單頁面應用', en: 'Single Page Application', icon: 'one' }
      ],
      companyIntroduction: [
        {
          text: "我們是一家專注於創新軟件開發的公司。",
          color: "rgb(64, 147, 57)"
        },
        {
          text: "我們的團隊擁有豐富的行業經驗和技術專長。",
          color: "rgb(108, 88, 234)"
        },
        {
          text: "致力於為客戶提供高質量的定製解決方案。",
          color: "rgb(184, 53, 53)"
        },
        {
          text: "我們追求卓越，幫助企業實現數碼化轉型。",
          color: "rgb(239, 200, 0)"
        }
      ],
      texts: [
        {
          name: "AI 賦能",
          color: "rgb(96, 201, 89)"
        },
        {
          name: "雲智未來",
          color: "rgb(252, 97, 73)"
        },
        {
          name: "鏈啟新篇",
          color: "rgb(63, 129, 254)"
        }
      ],
      proMessage: [
        {
          table: "數據加密，安全無憂",
          mes: "採用 AES-256 加密技術，嚴格權限管控，保障用戶數據全生命周期安全，定期通過 ISO/IEC 27001 認證審計。"
        },
        {
          table: "合規透明，用戶可控",
          mes: "嚴格遵循 GDPR/CCPA 等法規，提供數據訪問 / 刪除 / 更正權限，未經授權不向第三方共享，確保私隱政策可追溯。"
        },
        {
          table: "嚴控共享，定期審計",
          mes: "僅在用戶授權範圍內使用數據，合作方需簽訂保密協議，每年進行獨立安全審計，漏洞響應時間小於24 小時。"
        }
      ]

    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
</style>